module.exports = __webpack_public_path__ + "img/facilityInfo_2_1.c1f1d291.jpg";